export default "__VITE_ASSET__BaV4BmMC__"